<template>
  <BarChart :chartData="chartData" :options="options" />
</template>


<script setup>
import router from '@/router/index'
/*composables & states */
import { userUUID, clubUUID } from '@/shared/state';

import { defineProps, toRefs, ref, computed } from 'vue';
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);


const props = defineProps({
  chartData: {
    type: Object,
    default: null,
  }

});
let { chartData } = toRefs(props);
const options = ref({
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    // title: {
    //   display: true,
    //   text: 'Chart.js Doughnut Chart',
    // },
  },
});




</script>
